import React from 'react'
import { User } from '@core/entities/user'
import { Box, Flex, Text } from '@fundamentals'
import { Palette } from '@core/theme/color-palette-siteassist'
import { TaskTemplateStepType } from '@core/entities/task/TaskTemplateStep'
import { AuditAction } from '@core/entities/audit/AuditResult/types'
import { DotSeparator } from '@common/DotSeparator'

type ActivityTimelineItemBaseProps = {
  children?: React.ReactNode
  name: string
  user?: User
  date?: string
  type?: TaskTemplateStepType | 'DONE'
  active?: boolean
  lastStep?: boolean
  auditAction?: AuditAction
  bgColor?: string
  isModal?: boolean
  color?: string
}

export const TaskActivityBase: React.FC<ActivityTimelineItemBaseProps> = ({
  children,
  name,
  user,
  date,
  active,
  lastStep,
  bgColor,
  isModal,
  color = Palette.BlueGrey[500],
}) => {
  const activityTop = isModal ? 168 : 180

  return (
    <Flex alignItems='stretch' gap={1} pb={0.5}>
      <Flex flexDirection='column' alignItems='center' gap={0.5}>
        <Box
          sx={{
            bgcolor: bgColor,
            position: 'sticky',
            top: activityTop,
            pt: 0.2,
            zIndex: 9,
            // Match the title's line-height (see the 22px set on the name
            // below) and center the dot within it so the dot lines up with the
            // middle of the step name.
            height: '22px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              bgcolor: active ? color : Palette.Grey[400],
            }}
          />
        </Box>

        {!lastStep && (
          <Box
            flex={1}
            sx={{ width: '1px', height: '100%', bgcolor: Palette.Grey[400] }}
          />
        )}
      </Flex>
      <Box flex={1}>
        <Box
          sx={{
            bgcolor: bgColor,
            position: 'sticky',
            top: activityTop,
            zIndex: 9,
            pt: 0.2,
            pb: 1.5,
          }}
        >
          <Text fontWeight='500' fontSize='16px' lineHeight='22px'>
            {name}
          </Text>
          <DotSeparator>
            {user && (
              <Text fontSize='12px' color='text.secondary'>
                {user.getFullName()}
              </Text>
            )}
            {date && (
              <Text fontSize='12px' color='text.secondary'>
                {date}
              </Text>
            )}
          </DotSeparator>
        </Box>
        <Box pb={lastStep ? 0 : 2}>{children}</Box>
      </Box>
    </Flex>
  )
}
